<template>
  <div
    data-grid="nowrap"
    class="toggleable grid--va-center w-auto"
  >
    <span
      class="toggleable__label cursor-pointer"
      :class="{ 'toggleable__label--inactive': !status }"
      @click.prevent="setStatus(false)"
    >
      {{ labels.disabled }}
    </span>

    <AsyncToggleInput
      v-model="status"
      attributeName="environment"
      input-id="environment-toggle"
    />

    <span
      class="toggleable__label cursor-pointer"
      :class="{ 'toggleable__label--active': status }"
      @click.prevent="setStatus(true)"
    >
      {{ labels.enabled }}
    </span>
  </div>
</template>

<script>
import { defineComponent, defineAsyncComponent } from 'vue'

const AsyncToggleInput = defineAsyncComponent(() => import('./ToggleInput'))

export default defineComponent({
  name: 'DualToggleable',

  components: {
    AsyncToggleInput
  },

  props: {
    labels: {
      type: Object,
      required: true
    },

    modelValue: {
      type: Boolean,
      required: true
    }
  },

  emits: ['update:modelValue'],

  computed: {
    status: {
      get () {
        return this.modelValue
      },

      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  methods: {
    setStatus (v) {
      this.status = v
    }
  }
})
</script>

<style scoped lang="scss">
  .toggleable {
    &__label {
      --weight: 700;
      --color: rgb(var(--gray7));

      margin: 0 8px;

      color: var(--color);
      font: var(--weight) 1.2rem "Nunito", sans-serif;
      transition: .1s ease-in-out;

      &--active {
        --color: var(--primary);
      }

      &--inactive {
        --color: rgb(var(--orange2));
      }
    }

    :deep(label) {
      span {
        --width: 54px;
        --height: 28px;

        background-color: rgb(var(--orange2));

        &:after {
          --width-ball: 20px;
          --height-ball: 20px;

          border-radius: 20px;
        }
      }
    }
  }
</style>
